define('TescoMobile_Checkout/js/view/about/checkout-agreements',['jquery', 'uiComponent'], function ($, Component) {
  'use strict';

  var checkoutConfig = window.checkoutConfig,
    agreementManualMode = 1,
    agreementsConfig = checkoutConfig ? checkoutConfig.checkoutAgreements : {};
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/about/checkout-agreements'
    },
    isVisible: agreementsConfig.isEnabled,
    agreements: agreementsConfig.agreements,
    isAgreementRequired: function (element) {
      return element.mode == agreementManualMode;
    },
    getCheckboxId: function (agreementId) {
      return 'agreement_' + agreementId;
    },
    isSelected: function () {
      const checkedAgreementInputPath = '.checkout-about div.checkout-agreements input:checked',
        aboutConfirmButtonPath = '#about-buttons-container .button';
      $(aboutConfirmButtonPath).toggleClass('disabled', $(checkedAgreementInputPath).length < 1);
    }
  });
});

